import React from "react";
import BulkRegistrationModal from "../../components/BulkRegistrationModal";

export default function StudentBulkRegistrationModal({
  isOpen,
  onClose,
  onAdd,
  openAlert,
  defaultDepartment
}) {
  const handleBulkRegister = (data) => {
    data.forEach((item, idx) => {
      const newId = Date.now() + idx;
      onAdd({ ...item, id: newId });
    });
    openAlert(`${data.length}명이 등록되었습니다! 🎉`, "완료");
  };

  return (
    <BulkRegistrationModal
      isOpen={isOpen}
      onClose={onClose}
      type="student"
      onRegister={handleBulkRegister}
      openAlert={openAlert}
      defaultDepartment={defaultDepartment}
    />
  );
}
